import React, { useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { CartContext } from '../context/CartContext';
import logo from '../assets/logo.png';   // ✅ ADD THIS

export default function Navbar() {
  const { cart } = useContext(CartContext);
  const [open, setOpen] = useState(false);

  const count = cart.reduce((s, i) => s + (i.quantity || 0), 0);

  return (
    <>
      <nav className="navbar">
        <div className="container navbar-inner">

          {/* ✅ BRAND WITH LOGO */}
          <NavLink to="/" className="brand" onClick={() => setOpen(false)}>
            <img src={logo} alt="Aromora Logo" className="brand-logo" />
            <span className="brand-text">Aromora Naturals</span>
          </NavLink>

          {/* Hamburger */}
          <div className="hamburger" onClick={() => setOpen(true)}>
            ☰
          </div>

          {/* Left Side Menu */}
          <div className={`navlinks ${open ? 'open' : ''}`}>
            <div className="close-btn" onClick={() => setOpen(false)}>✕</div>

            <NavLink to="/" onClick={() => setOpen(false)}
              className={({ isActive }) => 'navlink' + (isActive ? ' active' : '')}>
              Home
            </NavLink>

            <NavLink to="/natural" onClick={() => setOpen(false)}
              className={({ isActive }) => 'navlink' + (isActive ? ' active' : '')}>
              Essential Oil
            </NavLink>

            <NavLink to="/artificial" onClick={() => setOpen(false)}
              className={({ isActive }) => 'navlink' + (isActive ? ' active' : '')}>
              Indian Spices
            </NavLink>

            <NavLink to="/contact" onClick={() => setOpen(false)}
              className={({ isActive }) => 'navlink' + (isActive ? ' active' : '')}>
              Contact
            </NavLink>

            <NavLink to="/about" onClick={() => setOpen(false)}
              className={({ isActive }) => 'navlink' + (isActive ? ' active' : '')}>
              About Us
            </NavLink>

            <NavLink to="/cart" onClick={() => setOpen(false)}
              className={({ isActive }) => 'navlink' + (isActive ? ' active' : '')}
              style={{ position: 'relative' }}>
              Cart
              {count > 0 && (
                <span className="cart-badge">{count}</span>
              )}
            </NavLink>
          </div>
        </div>
      </nav>

      {open && <div className="mobile-overlay" onClick={() => setOpen(false)} />}
    </>
  );
}
